export default "__VITE_ASSET__BKSUt$tz__"